import { Box, Button, Grid, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { styled } from '@mui/system';
import typography from 'src/theme/typography';

export const DisabledWrapper = styled(Grid)(({ theme }) => ({
  background: 'rgba(0,0,0,0.6)',
  width: '100%',
  height: '100%',
  padding: '5%',
  margin: 0,
  borderRadius: 20,
  zIndex: 10,
  color: '#fff'
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '24px',
  fontWeight: 700
}));

export const ContentText = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '16px',
  fontWeight: 400
}));

export const BoxWrapper = styled(Box)(({ theme }) => ({
  marginTop: '5%',
  marginBottom: '5%'
}));

export const ButtonWrapper = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.colorPalette[2],
  color: '#fff',
  borderRadius: 32,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  '&:hover': {
    backgroundColor: theme.palette.colorPalette[3],
    color: '#fff'
  }
}));
